import { methodPut, methodGet, methodPost, methodDelete, methodPatch } from './methods';

import { API_INFO } from '../constants';

export const getAllUsers = async (query) => {
  return methodGet(API_INFO + `users/users/`, query);
};

export const getDetailUser = (user) => {
  const url = API_INFO + `users/users/${user}/`;
  return methodGet(url);
};

export const createUser = async (payload) => {
  const url = API_INFO + 'users/users/';
  return methodPost(url, payload);
};

export const editUser = async (id, payload) => {
  const url = API_INFO + `users/users/${id}/`;
  return methodPatch(url, payload);
};

export const deleteUser = async (user) => {
  return methodDelete(API_INFO + `users/users/${user}/`);
};

export const changePassword = async (payload) => {
  return methodPut(API_INFO + 'users/actions/change-password-current-user/', payload);
};

export const changePasswordIntranetUser = async (payload) => {
  return methodPost(API_INFO + 'users/actions/change-password-another-user/', payload);
};

export const recoverPassword = async (payload) => {
  return methodPost(API_INFO + 'users/actions/recover-password/', payload);
};

export const changeRecoverPassword = async (payload) => {
  return methodPut(API_INFO + 'users/actions/change-recover-pass/', payload);
};

export const saveChanges = async (payload, id) => {
  return methodPatch(API_INFO + `users/users/${id}/`, payload);
};

export const infoUser = async () => {
  return methodGet(API_INFO + 'users/users/info/', {});
};

export const getUserPermissions = async () => {
  return methodGet(API_INFO + 'users/users/permissions/', {});
};

export const saveFavoriteProductUser = async (payload) => {
  return methodPost(API_INFO + 'user/save-product/', payload);
};

export const deleteFavoriteProductUser = async (id) => {
  return methodDelete(API_INFO + `user/save-product/${id}`);
};

export const registerUser = async (payload) => {
  return methodPost(API_INFO + 'users/users/', payload);
};

export const getUsersBySearch = async (query) => {
  return methodGet(API_INFO + `users/users/`, query);
};
export const getUserById = async (id) => {
  return methodGet(API_INFO + `users/users/${id}`);
};

export const getMyOrders = async () => {
  return methodGet(API_INFO + 'storehouse/orders/get_orders_by_user/');
};


export async function getClientsByName(payload) {
  return methodGet(API_INFO + 'user/clients/', payload);
}

export async function getUserLibraryContest(payload) {
  return methodGet(API_INFO + 'users/users/', payload);
}

export const getCommercialsApi = (payload) => {
  const url = API_INFO + `user/commercials/`;
  return methodGet(url, payload);
};

export const postContact = async (payload) => {
  const url = API_INFO + 'user/contact/';
  return methodPost(url, payload);
};

export const getFavorites = (payload) => {
  const url = API_INFO + `user/save-product/`;
  return methodGet(url, payload);
};

export const updateUserById = (id, payload) => {
  return methodPatch(API_INFO + `users/users/${id}/`, payload);
}

export const createBudget = async (payload) => {
  return methodPost(API_INFO + 'users/library-budget/', payload);
}

export const updateBudget = async (id, payload) => {
  return methodPatch(API_INFO + `users/library-budget/${id}/`, payload);
}

export const postManualReturn = async (payload) => {
  const url = API_INFO + 'storehouse/returns/manual_return/';
  return methodPost(url, payload);
};